import { useQuery } from '@tanstack/react-query';
import { getPrintoutConfiguration } from './getPrintoutConfiguration';
import { COMPANY_API_SETTINGS_MOCKED } from '@/env';
import { mockPrintoutConfiguration } from './mock';
import { PrintoutConfigurationModel } from './types';
import { QUERY_KEY_SETTINGS_PRINTOUT, SETTINGS_QUERY_NO_CACHE } from '@/lib/api/constants'

type Props = {
  companyId: string
}

export function useQueryPrintoutConfiguration(props: Props) {
  const { companyId } = props
  return useQuery<PrintoutConfigurationModel>({
    queryKey: [QUERY_KEY_SETTINGS_PRINTOUT, companyId],
    queryFn: async () => {
      if (COMPANY_API_SETTINGS_MOCKED) {
        return mockPrintoutConfiguration
      }
      // @TODO remove companyId from queryKey and endpoint when backend is fixed
      const { data } = await getPrintoutConfiguration(props);
      return data;
    },
    ...SETTINGS_QUERY_NO_CACHE,
  });
}
